import { makeStyles } from '@material-ui/core/styles';

export default makeStyles({
  verifyButton: {
    color: '#4caf50',
  },
  notVerifiedButton: {
    color: '#c0392b',
  }
});
